import { useEffect, useState } from 'react';
import { SvgEstrellas } from '../../../../icons'; // ajusta la ruta según tu estructura
import { safeFetch } from '@/api/safeFetch';

interface ResumenValoraciones {
  profesionalId: number;
  cantidad: number;
  suma: number;
  media: number;
}

const ResumenValoraciones: React.FC<{ profesionalId: number }> = ({ profesionalId }) => {
  const [resumen, setResumen] = useState<ResumenValoraciones | null>(null);
  useEffect(() => {
    if (!profesionalId) return; // evita llamar con 0 o undefined
    const fetchResumenValoraciones = async () => {
      try {
          // 🟢 Llamada a la API usando variable de entorno
        const res = await safeFetch(`/api/valoraciones/resumen/${profesionalId}`);
        if (!res.ok) throw new Error('Error al obtener resumen de valoraciones');
        const data = await res.json();
        setResumen({
          ...data,
          media: parseFloat(data.media),
        });
      } catch (error) {
        console.error('Error en fetchResumenValoraciones:', error);
      }
    };
  
    fetchResumenValoraciones();
  }, [profesionalId]);
  

  if (!resumen) {
    return <p className="text-zinc-500 text-sm">Cargando resumen de valoraciones...</p>;
  }

  const renderEstrellas = (media: number) => {
    return Array.from({ length: 5 }).map((_, i) => {
      const fillPercentage = Math.min(Math.max(media - i, 0), 1) * 100;
      return <SvgEstrellas key={i} index={i} fillPercentage={fillPercentage} />;
    });
  };

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-center w-full text-center md:text-left">
      <div className="flex justify-center md:justify-start">
        {renderEstrellas(resumen.media)}
      </div>

      <div className="hidden md:block text-zinc-700 font-semibold text-lg md:ml-4 md:pr-2">
        {resumen.cantidad > 0
          ? `${resumen.media.toFixed(1)} / ${resumen.cantidad} valoraciones` // muestra media y cantidad
          : 'Sin valoraciones'}
      </div>
    </div>
  );
};

export default ResumenValoraciones;
